<template>
  <li class="education-purchase-requests-tab">
    <div class="education-purchases__heading">
      <h4>{{ $t("general.my_purchase_requests") }} ({{ purchases.length }})</h4>
      <h4>
        {{ $t("general.remaining_user_count") }}
        ({{ item.total_users_allowed || 0 }})
      </h4>
    </div>

    <div class="table-responsive">
      <table class="table align-items-center">
        <thead>
        <tr>
          <th scope="col">{{ $t("general.request_type") }}</th>
          <th scope="col">{{ $t("general.request_date") }}</th>
          <th scope="col">{{ $t("general.status") }}</th>
          <th scope="col">{{ $t("general.verification_date") }}</th>
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody class="list">
        <tr v-for="(purchase, index) in purchases"
            :key="purchase.id || 'training_purchase_' + index"
        >
          <th scope="row">
            <div class="media align-items-center">
              <div class="media-body">
                <p class="name h6 mb-0 text-sm">
                  {{ requestTypes[purchase.request_type_id] }}
                  ({{ purchase.number_of_users }} {{ $t("general.user") }})
                </p>
                <small class="d-block font-weight-bold"
                >#{{ purchase.id }}</small
                >
              </div>
            </div>
          </th>
          <td>{{ toDate(purchase.created_at) }}</td>
          <td :class="statusClass(purchase.status_id)">
            <i v-if="purchase.status_id == 1"
               aria-hidden="true"
               class="uil-clock-eight"
            ></i>
            {{ getPurchaseStatus(purchase.status_id) }}
          </td>
          <td>{{ toDate(purchase.approved_at) }}</td>
          <td class="text-right">
            <div class="actions ml-3">
              <button v-if="purchase.status_id != 2"
                      :uk-tooltip="$t('general.send_message')"
                      class="btn btn-icon btn-hover btn-sm btn-circle"
                      type="button"
                      uk-toggle="target: #message_modal"
              >
                <i aria-hidden="true" class="uil-envelope"></i>
              </button>
              <button v-if="purchase.status_id == 1"
                      :uk-tooltip="$t('general.cancel_request')"
                      class="btn btn-icon btn-hover btn-sm btn-circle"
                      type="button"
                      @click="$emit('remove-purchase', purchase.id, index)"
              >
                <i
                    aria-hidden="true"
                    class="uil-times-circle text-danger"
                ></i>
              </button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div id="message_modal" class="uk-flex-top" uk-modal>
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
        <div class="uk-modal-header pl-0">
          <h2 class="uk-modal-title">
            {{ $t("general.send_message_to_admin") }}
          </h2>
          <button class="uk-modal-close-default"
                  type="button"
                  uk-close
          ></button>
        </div>
        <div class="uk-modal-body pl-0 pr-0">
          <textarea id="content"
                    :placeholder="$t('general.your_message')"
                    :value="message"
                    class="form-control"
                    name="content"
                    @input="$emit('update:message', $event.target.value)"
          ></textarea>
        </div>
        <div class="uk-modal-footer pl-0 pr-0 d-flex justify-content-end">
          <button class="uk-button uk-button-primary small"
                  type="button"
                  @click="$emit('send-message')"
          >
            <i aria-hidden="true" class="icon-feather-arrow-right"></i>
            {{ $t("general.send") }}
          </button>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import moment from "moment";

export default {
  name: "EducationPurchaseRequestsTab",
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    message: {
      type: String,
      default: "",
    },
    requestTypes: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    purchases() {
      return Array.isArray(this.item.purchases) ? this.item.purchases : [];
    },
  },
  methods: {
    getPurchaseStatus(id) {
      switch (id) {
        case 0:
          return this.$t("general.approval_not_granted");
        case 1:
          return this.$t("general.waiting_for_response");
        case 2:
          return this.$t("general.approval_granted");
        default:
          return "-";
      }
    },
    statusClass(statusId) {
      return {
        "education-purchases__status--approved": statusId == 2,
        "education-purchases__status--rejected": statusId == 0,
      };
    },
    toDate(date) {
      return date ? moment(date).format("DD-MM-YYYY HH:mm:ss") : "-";
    },
  },
};
</script>

<style scoped>
.education-purchases__heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table {
  min-width: 720px;
  margin-bottom: 0;
}

.table th,
.table td {
  vertical-align: middle;
}

.education-purchases__status--approved {
  color: green;
  font-weight: 700;
}

.education-purchases__status--rejected {
  color: indianred;
  font-weight: 700;
}

@media (max-width: 767px) {
  .education-purchases__heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }

  .education-purchases__heading h4 {
    margin-bottom: 0;
    font-size: 16px;
    line-height: 1.5;
  }

  #message_modal .uk-modal-dialog {
    width: calc(100% - 32px);
  }
}
</style>
